import type { ClinicAccessResponse } from '../infrastructure/clinicAccess.api';

export type PermissionMode = 'any' | 'all';

export function hasClinicCapability(
  access: ClinicAccessResponse | undefined,
  permissions: readonly string[],
  feature?: string,
  permissionMode: PermissionMode = 'any',
): boolean {
  if (!access) return false;
  const hasPermission = permissions.length > 0 && (
    permissionMode === 'all'
      ? permissions.every((permission) => access.permissions.includes(permission))
      : permissions.some((permission) => access.permissions.includes(permission))
  );
  return hasPermission && (!feature || access.enabledFeatures.includes(feature));
}
